import React, {Component} from "react";
import { observer } from "mobx-react";
import Switch, { Case } from 'react-switch-case';
import {fn_menuSoldOut} from "../../../../function/FnBodyMenu";

@observer
class SoldOutConfirmView extends Component {

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_alert "+(layerStore.getLayerSoldOutConfirmView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <Switch condition={layerStore.getLayerSoldOutConfirmType}>
                            <Case value="action">
                                <div className="section_tit_comm">
                                    <h1>품절처리</h1>
                                </div>
                                <div className="section_soldout">
                                    <p className="txt_detail">
                                        선택하신 상품을 품절처리 하시겠습니까?<br />품절처리 시, 연결메뉴에 동시에 적용됩니다.
                                    </p>
                                    <div className="wrap_full_btn wrap_full_btn2">
                                        <span className="f_l"><button className="btn_cancel" onClick={(e)=> layerStore.setLayerSoldOutConfirmView(false) }>취소</button></span>
                                        <span className="f_r"><button className="btn_submit" onClick={(e)=> {fn_menuSoldOut(rootStore, true)}}>확인</button></span>
                                    </div>
                                </div>
                                <div className="btn_close btn_close_comm">
                                    <button onClick={event => layerStore.setLayerSoldOutConfirmView(false) }><span>닫기</span></button>
                                </div>
                            </Case>
                            <Case value="cancel">
                                <div className="section_tit_comm">
                                    <h1>품절해제</h1>
                                </div>
                                <div className="section_soldout">
                                    <p className="txt_detail">
                                        품절을 해제하시겠습니까?<br />품절처리 시, 연결메뉴에 동시에 적용됩니다.
                                    </p>
                                    <div className="wrap_full_btn wrap_full_btn2">
                                        <span className="f_l"><button className="btn_cancel" onClick={event => layerStore.setLayerSoldOutConfirmView(false) }>취소</button></span>
                                        <span className="f_r"><button className="btn_submit" onClick={(e)=>{
                                            fn_menuSoldOut(rootStore, false)
                                        }}>확인</button></span>
                                    </div>
                                </div>
                                <div className="btn_close btn_close_comm">
                                    <button onClick={event => layerStore.setLayerSoldOutConfirmView(false) }><span>닫기</span></button>
                                </div>
                            </Case>
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}

export default SoldOutConfirmView;